(function () {
  if (window.uxChooseSetupInit) return;
  window.uxChooseSetupInit = true;

  var CARD = '.ux-cys__card[data-variant-id]';
  var FALLBACK_MS = 4000; // safety net if the SlideCart event never arrives
  var scheduleRefresh = function () {}; // assigned in initRefresh()

  function addUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return root + 'cart/add.js';
  }

  // Radio: selecting a card deselects the others in its group; clicking the selected
  // card again turns it off (add-ons are optional, so "none selected" is allowed).
  function toggle(card) {
    if (card.classList.contains('is-locked')) return;
    var wasSelected = card.classList.contains('is-selected');
    var root = card.closest('[data-ux-cys]');
    if (root) {
      root.querySelectorAll('.ux-cys__card[data-variant-id].is-selected').forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
      });
    }
    if (!wasSelected) {
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');
    }
  }

  // Whole card is the toggle (no per-card button, by design).
  document.addEventListener('click', function (e) {
    var card = e.target.closest(CARD);
    if (card) { toggle(card); scheduleRefresh(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter' && e.key !== 'Spacebar') return;
    var card = e.target.closest && e.target.closest(CARD);
    if (!card) return;
    e.preventDefault();
    toggle(card);
    scheduleRefresh();
  });

  function selectedIds(root) {
    var ids = [];
    root.querySelectorAll('.ux-cys__card.is-selected[data-variant-id]').forEach(function (c) {
      var id = c.getAttribute('data-variant-id');
      if (id) ids.push(Number(id));
    });
    return ids;
  }

  function masterVariants(root) {
    try {
      return JSON.parse(root.getAttribute('data-master-variants') || '[]').map(Number);
    } catch (e) {
      return [];
    }
  }

  var adding = false;
  function addSelected(root) {
    if (adding) return;
    var items = [];
    root.querySelectorAll('.ux-cys__card.is-selected[data-variant-id]').forEach(function (c) {
      var id = Number(c.getAttribute('data-variant-id'));
      if (!id) return;
      var q = Math.max(1, parseInt(c.getAttribute('data-cys-qty'), 10) || 1);
      items.push({ id: id, quantity: q });
    });
    if (!items.length) return;
    adding = true;
    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function () {
        if (typeof window.SLIDECART_UPDATE === 'function') {
          window.SLIDECART_UPDATE(window.SLIDECART_OPEN);
        }
      })
      .catch(function (err) { console.error('[ux-cys] add-on add failed', err); })
      .finally(function () { adding = false; });
  }

  // Parse a money string to a number, tolerant of both "1,234.56" and "1.234,56".
  function parseMoney(str) {
    if (!str) return NaN;
    var s = String(str).replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var m = s.match(/[.,](\d{1,2})$/);
    if (m) {
      var dec = m[0].charAt(0);
      var parts = s.split(dec);
      var frac = parts.pop();
      return parseFloat(parts.join('').replace(/[.,]/g, '') + '.' + frac);
    }
    return parseFloat(s.replace(/[.,]/g, ''));
  }

  function firstText(el) { return el && el.textContent ? el.textContent.trim() : ''; }

  // Read a rendered .price element's displayed "was" (struck) and "now" (sale/regular),
  // covering the theme's native sale markup AND the automatic-discount script's rewrite.
  function readWasNow(priceEl) {
    if (!priceEl) return null;
    var nowEl = priceEl.querySelector('.price__sale .price-item--sale') ||
      priceEl.querySelector('.price-item--last') ||
      priceEl.querySelector('.price-item--sale');
    var nowStr = firstText(nowEl);
    var nowVal = parseMoney(nowStr);
    if (!isFinite(nowVal)) {
      var regEl = priceEl.querySelector('.price__regular .price-item--regular') ||
        priceEl.querySelector('.price-item--regular');
      nowStr = firstText(regEl);
      nowVal = parseMoney(nowStr);
      if (!isFinite(nowVal)) return null;
      return { nowVal: nowVal, wasVal: nowVal, nowStr: nowStr, wasStr: nowStr };
    }
    var wasEl = priceEl.querySelector('.price__sale s.price-item--regular') ||
      priceEl.querySelector('.price__sale .price-item--regular') ||
      priceEl.querySelector('s.price-item--regular');
    var wasStr = firstText(wasEl);
    var wasVal = parseMoney(wasStr);
    if (!isFinite(wasVal) || wasVal < nowVal) { wasVal = nowVal; wasStr = nowStr; }
    return { nowVal: nowVal, wasVal: wasVal, nowStr: nowStr, wasStr: wasStr };
  }

  // Format `amount` the same way as a sample money string on the page (currency symbol,
  // suffix, and thousand/decimal separators are all inferred from the sample).
  function formatLike(sample, amount) {
    if (!sample) return String(amount);
    var tokenMatch = sample.match(/\d[\d.,]*/);
    if (!tokenMatch) return sample;
    var token = tokenMatch[0];
    var dm = token.match(/([.,])(\d{1,2})$/);
    var dec = dm ? dm[1] : '.';
    var decimals = dm ? dm[2].length : 0;
    var thou = dec === '.' ? ',' : '.';
    var parts = amount.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var formatted = parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
    return sample.replace(token, formatted);
  }

  // Derive the discount % from the card's *displayed* price, so the badge always matches.
  function cardDiscountPct(card) {
    var wn = readWasNow(card.querySelector('.ux-cys__price .price'));
    if (!wn || wn.wasVal <= 0 || wn.nowVal >= wn.wasVal) return 0;
    return Math.round((1 - wn.nowVal / wn.wasVal) * 100);
  }

  function refreshBadges(roots) {
    roots.forEach(function (root) {
      root.querySelectorAll('.ux-cys__card[data-variant-id]').forEach(function (card) {
        var badge = card.querySelector('[data-cys-badge]');
        if (!badge) return;
        var pct = cardDiscountPct(card);
        if (pct > 0) { badge.textContent = 'Save ' + pct + '%'; badge.hidden = false; }
        else { badge.hidden = true; }
      });
    });
  }

  function getSectionId(root) {
    return (root.getAttribute('data-product-form') || '').replace(/^product-form-/, '');
  }

  function buildTotalMarkup(onSale, wasStr, nowStr) {
    if (onSale) {
      return '<div class="price__container"><div class="price__sale">' +
        '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
        '<s class="price-item price-item--regular">' + wasStr + '</s> ' +
        '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
        '<span class="price-item price-item--sale price-item--last">' + nowStr + '</span>' +
        '</div></div>';
    }
    return '<div class="price__container"><div class="price__regular">' +
      '<span class="price-item price-item--regular">' + nowStr + '</span>' +
      '</div></div>';
  }

  // Render the total into one price "surface": a total node placed next to the original,
  // which we hide. When inactive, restore the original and hide our node. The summed values
  // are shared across surfaces; each surface formats them from its own displayed price string.
  function applyTotalToSurface(surface, active, onSale, sumNow, sumWas) {
    var container = surface.container;
    var totalNode = container.querySelector('.ux-cys-total-price');
    if (!active) {
      if (totalNode) totalNode.style.display = 'none';
      surface.hideEl.style.display = '';
      surface.hideEl.removeAttribute('aria-hidden');
      return;
    }
    var nowStr = formatLike(surface.sampleNow, sumNow);
    var wasStr = formatLike(surface.sampleWas, sumWas);
    if (!totalNode) {
      totalNode = document.createElement('div');
      totalNode.className = surface.className + ' ux-cys-total-price';
      totalNode.setAttribute('role', 'status');
      container.insertBefore(totalNode, surface.anchor.nextSibling);
    }
    totalNode.classList.toggle('price--on-sale', onSale);
    totalNode.classList.toggle('bch-has-discounted-price', onSale);
    totalNode.innerHTML = buildTotalMarkup(onSale, wasStr, nowStr);
    totalNode.style.display = '';
    surface.hideEl.style.display = 'none';
    surface.hideEl.setAttribute('aria-hidden', 'true');
  }

  // PDP price row AND the sticky add-to-cart price = master price + every selected add-on
  // (both "was" and "now" summed). Falls back to the untouched master price when nothing
  // is selected. The master base is read from the main #price (authoritative); the sticky
  // only supplies its own money format so its currency style is preserved.
  function updateTotal(root) {
    var id = getSectionId(root);
    var wrap = id ? document.getElementById('price-' + id) : null;
    if (!wrap) return;
    var master = readWasNow(wrap.querySelector('.price'));
    var selected = root.querySelectorAll('.ux-cys__card.is-selected[data-variant-id]');
    var active = !!master && selected.length > 0;

    var sumNow = 0, sumWas = 0, onSale = false;
    if (active) {
      sumNow = master.nowVal;
      sumWas = master.wasVal;
      selected.forEach(function (card) {
        var wn = readWasNow(card.querySelector('.ux-cys__price .price'));
        if (wn) { sumNow += wn.nowVal; sumWas += wn.wasVal; }
      });
      onSale = sumWas > sumNow + 0.005;
    }

    // Surface 1 — main PDP price row.
    applyTotalToSurface({
      hideEl: wrap,
      container: wrap.parentNode,
      anchor: wrap,
      className: 'price price--large',
      sampleNow: master ? master.nowStr : '',
      sampleWas: master ? master.wasStr : ''
    }, active, onSale, sumNow, sumWas);

    // Surface 2 — sticky add-to-cart price (present only once scrolled/rendered).
    var stickyPrice = document.querySelector('#bch-sticky-add-to-cart .pdp-sticky-add-to-cart__price');
    if (stickyPrice && stickyPrice.parentNode) {
      var sBase = readWasNow(stickyPrice);
      applyTotalToSurface({
        hideEl: stickyPrice,
        container: stickyPrice.parentNode,
        anchor: stickyPrice,
        className: 'price',
        sampleNow: sBase ? sBase.nowStr : (master ? master.nowStr : ''),
        sampleWas: sBase ? sBase.wasStr : (master ? master.wasStr : '')
      }, active, onSale, sumNow, sumWas);
    }
  }

  function initRefresh(roots) {
    var rootArr = Array.prototype.slice.call(roots);
    var scheduled = false;
    var rowObs = []; // { ob, target } — disconnected while we write, to avoid self-triggering

    function refreshNow() {
      rowObs.forEach(function (o) { o.ob.disconnect(); });
      try {
        refreshBadges(rootArr);
        rootArr.forEach(updateTotal);
      } finally {
        rowObs.forEach(function (o) {
          o.ob.observe(o.target, { childList: true, subtree: true, characterData: true });
        });
      }
    }

    scheduleRefresh = function () {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        scheduled = false;
        refreshNow();
      });
    };

    // Recompute when the master price row re-renders (variant change) or the discount
    // script rewrites it. The row observer is disconnected during our own writes.
    rootArr.forEach(function (root) {
      var id = getSectionId(root);
      var wrap = id ? document.getElementById('price-' + id) : null;
      if (!wrap) return;
      var target = wrap.parentNode;
      var ob = new MutationObserver(function () { scheduleRefresh(); });
      rowObs.push({ ob: ob, target: target });
      ob.observe(target, { childList: true, subtree: true, characterData: true });
    });

    // Recompute when bch-automatic-discount-prices.js rewrites a card price.
    rootArr.forEach(function (root) {
      root.querySelectorAll('.ux-cys__price').forEach(function (priceWrap) {
        new MutationObserver(function () { scheduleRefresh(); })
          .observe(priceWrap, { childList: true, subtree: true, characterData: true });
      });
    });

    scheduleRefresh();
    // Fallback passes in case the discount API resolves late.
    [800, 2000, 3500].forEach(function (t) { setTimeout(refreshNow, t); });
  }

  function hook() {
    var roots = document.querySelectorAll('[data-ux-cys]');
    if (!roots.length) return;

    initRefresh(roots);

    var pending = false;
    var timer = null;

    function isMasterForm(form) {
      // NB: form.id is shadowed by the <input name="id"> control inside the buy form,
      // so it returns that element, not the id string — always read the attribute.
      if (!form || !form.getAttribute) return false;
      var fid = form.getAttribute('id');
      if (!fid) return false;
      return Array.prototype.some.call(roots, function (r) {
        return r.getAttribute('data-product-form') === fid;
      });
    }

    function masterInCart(cart) {
      if (!cart || !cart.items) return false;
      var mv = [];
      roots.forEach(function (r) { mv = mv.concat(masterVariants(r)); });
      if (!mv.length) return true; // unknown -> don't block the flush
      return cart.items.some(function (it) {
        return mv.indexOf(Number(it.variant_id)) !== -1 || mv.indexOf(Number(it.id)) !== -1;
      });
    }

    // Arm on the user's intent to add the MASTER product (button click or form submit).
    // Only arms when at least one add-on card is selected.
    function arm() {
      var any = false;
      roots.forEach(function (r) { if (selectedIds(r).length) any = true; });
      if (!any) return;
      pending = true;
      if (timer) clearTimeout(timer);
      timer = setTimeout(flush, FALLBACK_MS);
    }

    function flush() {
      if (!pending) return;
      pending = false;
      if (timer) { clearTimeout(timer); timer = null; }
      roots.forEach(addSelected);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[name="add"], [type="submit"][name="add"]');
      if (!btn) return;
      if (isMasterForm(btn.closest('form'))) arm();
    }, true);

    document.addEventListener('submit', function (e) {
      if (isMasterForm(e.target)) arm();
    }, true);

    // Completion signal: AMP Slide Cart finished updating after the master add.
    // Fires on every cart update, so we only act when armed AND the master is in the cart,
    // then disarm immediately — our own add-on add (which re-fires this event) is ignored.
    document.addEventListener('BchSlideCartUpdated', function (event) {
      if (!pending) return;
      var cart = event && event.detail ? event.detail.cart : null;
      if (masterInCart(cart)) flush();
    });
  }

  if (document.readyState !== 'loading') hook();
  else document.addEventListener('DOMContentLoaded', hook);
})();
